export const environment = {
  production: 'true',
  envName: 'production',
  AYEN_API_URL: 'https://api.ayen.com.sa/api',
  GOOGLE_API_KEY: 'AIzaSyDhx3TZy2i2dlVi8DfA4uMUBJ6BTzUxj4o',
  DSN_URL: 'https://131f358d98cc4e1fa29991f0c71fc36f@o688178.ingest.sentry.io/5773232',
  SMART_LOOK_ACCESS_KEY: '1b0a1e0437625e9eecf18bd3274db84352958324',
};